import {sprintf} from 'sprintf-js';
import Validation from 'js/utils/validation';
import {MESSAGE} from 'js/constants';

/**
 * check
 * @param {object} form
 * @param {object} error
 * @return {object}
 */
export default function checkForm(form, error) {
  // 会社名
  if (!Validation.required(form.company)) {
    error.company = MESSAGE.validation.required;
  } else if (!Validation.max(String(form.company), 100)) {
    error.company = sprintf(MESSAGE.validation.max, 100);
  }

  // 部署
  if (!Validation.required(form.unit)) {
    error.unit = MESSAGE.validation.required;
  } else if (!Validation.max(String(form.unit), 100)) {
    error.unit = sprintf(MESSAGE.validation.max, 100);
  }

  // 氏名
  if (!Validation.required(form.name)) {
    error.name = MESSAGE.validation.required;
  } else if (!Validation.max(String(form.name), 100)) {
    error.name = sprintf(MESSAGE.validation.max, 100);
  }

  // メールアドレス
  if (!Validation.required(form.email)) {
    error.email = MESSAGE.validation.required;
  } else if (!Validation.email(form.email)) {
    error.email = MESSAGE.validation.format;
  } else if (!Validation.freeDomain(form.email)) {
    error.email = MESSAGE.validation.freedomain;
  }

  // 電話番号
  if (!Validation.required(form.tel)) {
    error.tel = MESSAGE.validation.required;
  } else if (!Validation.max(String(form.tel), 20)) {
    error.tel = sprintf(MESSAGE.validation.max, 20);
  }

  // 利用規約
  if (!Validation.required(form.agree)) {
    error.agree = MESSAGE.validation.agree;
  }

  return error;
}



// WEBPACK FOOTER //
// ./src/js/stores/registration/check-form.js